// js
import React from 'react';
import PropTypes from 'prop-types';
import DonutSliceChart from '../common/DonutSliceChart';
import { generateSecurityOverviewSliceChartProps, generateSecurityOverviewSliceLabel } from '../../utils/securityAnalysis';


const SecurityOverviewSlice = ({ data, criticality, adequacy }) => {
  return (
    <div className='security-overview-slice'>
      <div className='row'>
        <div className='col-md-4'>
          <DonutSliceChart
            {...generateSecurityOverviewSliceChartProps(data, criticality, adequacy)}
          />
        </div>
        <div className='col-md-8'>
          <div className='security-overview-slice__description'>
            {generateSecurityOverviewSliceLabel(data, criticality, adequacy)}
          </div>
        </div>
      </div>
    </div>
  );
};

SecurityOverviewSlice.propTypes = {
  data: PropTypes.object.isRequired,
  criticality: PropTypes.string.isRequired,
  adequacy: PropTypes.string.isRequired
};

export default SecurityOverviewSlice;



// WEBPACK FOOTER //
// ./src/components/analytics/SecurityOverviewSlice.js